import { BasicRequest } from "./basicRequest";

export class PublishFilterDefinitionRequest extends BasicRequest{
    public filterDefinitionId!:number;
    public published:boolean = false;

    constructor(){
        super();
    }
}